module.exports = __webpack_public_path__ + "static/mccarthy-hall-4-52f8b0ba86b0f47bbe506ea042d8d913.jpg";